import routes from '../../router/routes'


export const routesInfos = {
  // home: {
  //   label: 'routeHomeLabel',
  //   route: routes.home.path,
  // },

  // allProjects: {
  //   label: 'allProjects',
  //   route: routes.allProjects.path,
  // },

  // brandsPlatform: {
  //   label: 'brandsPlatformLink',
  //   route: routes.projects.path,
  //   routeParams: {
  //     domain: 'brands',
  //   },
  //   menuImage: 'menu_image_1.jpg'
  // },
  // digitalActivations: {
  //   label: 'digitalActivationsLink',
  //   route: routes.projects.path,
  //   routeParams: {
  //     domain: 'digital',
  //   },
  //   menuImage: 'menu_image_2.jpg'
  // },
  // mobileApps: {
  //   label: 'mobileAppsLink',
  //   route: routes.projects.path,
  //   routeParams: {
  //     domain: 'mobileApp',
  //   },
  //   menuImage: 'menu_image_3.jpg'
  // },
  // businessTools: {
  //   label: 'businessToolsLink',
  //   route: routes.projects.path,
  //   routeParams: {
  //     domain: 'business',
  //   },
  //   menuImage: 'menu_image_4.jpg'
  // },

  studio: {
    label: 'routeStudioLabel',
    route: routes.studio.path,
  },
  jobs: {
    label: 'routeJobLabel',
    link: 'https://www.welcometothejungle.co/companies/big-boss-studio',
  },
}
